<template lang="html">

  <section class="dashboard">
    <div class="pageHeading">
        <v-layout row wrap>
          <v-flex xs6 md3>
            <h2 style="vertical-align: text-top;">Dashboard</h2>
          </v-flex>
          <v-flex xs6 md9 text-md-right text-xs-right>
            <v-btn v-if="$structuredData.trips != undefined && $structuredData.trips.length > 1"
                small @click="$router.push('/SelectTrip')" color="primary">Switch Trip</v-btn>
          </v-flex>
        </v-layout>
    </div>
    <v-container grid-list-md text-xs-center>
    <v-layout row wrap>
      <v-flex xs12 md4>
        <v-card>
          <v-card-title primary-title>
            <v-flex>
              <h3 class="headline mb-0">Trips</h3>
              <div>Register for your trip or view any trip you have already registered for</div>
            </v-flex>
          </v-card-title>

          <v-card-actions>
            <v-layout row wrap>
            <v-flex

                    pa-1  style="border-top: lightgray 1px solid;">

            <v-btn @click="$router.push('/AddTrip')" color="secondary" dark>Add Trip</v-btn>
            <v-btn @click="$router.push('/Trips')" color="primary">My Trips</v-btn>
            </v-flex>
            </v-layout>

          </v-card-actions>
        </v-card>
      </v-flex>
      <v-flex xs12 md4>

        <v-card>

          <v-card-title primary-title>
            <v-flex>
              <h3 class="headline mb-0">Tour Participants</h3>
              <div>List all travelers being billed to your account or add one</div>
            </v-flex>
          </v-card-title>





          <v-card-actions>
            <v-layout row wrap>
              <v-flex

                      pa-1  style="border-top: lightgray 1px solid;">

                <v-btn  @click="$router.push('/AddTraveler')"   color="secondary" dark>Add Traveler</v-btn>
                <v-btn @click="$router.push('/Participants')" color="primary">My Travelers</v-btn>
              </v-flex>
            </v-layout>
          </v-card-actions>
        </v-card>
      </v-flex>

      <v-flex xs12 md4 text-xs-center>
        <v-card elevation="5" style="border: 0px solid rgba(0, 0, 0);">
          <v-card-title primary-title>
            <v-flex  v-if="1==2">
              <h3 class="headline mb-0">Trip Notifications</h3>
              <div>Check the latest trip updates relevant to you</div>
            </v-flex>
            <v-flex v-if="1==1">
              <h3 class="headline mb-0">Trip Notifications</h3>
              <v-alert v-if="$structuredData.notifications.length - $userData.notifsRead > 0" style="padding: 4px;"
                       :value="true"
                       color="warning"
                       icon="priority_high"
                       outline
              >
                <span>You Have {{$structuredData.notifications.length - $userData.notifsRead}} Unread Notifications</span>
              </v-alert>

              <v-alert v-else style="padding: 4px;"
                       :value="true"
                       color="success"
                       icon="check_circle"
                       outline
              >
                <span>You Have 0 Unread Notifications</span>
              </v-alert>

            </v-flex>
          </v-card-title>



          <v-card-actions>
            <v-layout row wrap>
              <v-flex

                      pa-1  style="border-top: lightgray 1px solid;">

                <v-btn  @click="$router.push('/TripNews')"   color="primary" dark>My Notifications</v-btn>
              </v-flex>
            </v-layout>
          </v-card-actions>


        </v-card>
      </v-flex>

    </v-layout>

      <br/>

      <v-divider inset></v-divider>
      <br/>

      <v-layout row wrap>


        <v-flex xs12 md12>


          <v-card elevation="5" style="border: 0px solid rgba(0, 0, 0);">
            <v-card-title primary-title>
              <v-flex xs12 md4 text-xs-center>
                <h3 class="headline mb-0">Payment Statuses</h3>
              <p></p>
                <p style="color:red">YOU MUST LOG IN AND MANUALLY MAKE EACH PAYMENT ON OR BEFORE YOUR DUE DATE. THERE IS NOT AN OPTION FOR AUTO PAY. THANK YOU!</p>


                <p style="color:red">Note: payments will be in pending status for up to 24 hours before being processed</p>
                <v-btn :disabled="!hasEnabledParticipants"  @click="$router.push('/MakePayment')"   color="primary" dark>Make Payment</v-btn>
              </v-flex>

              <v-flex xs12 md8 text-xs-center>
                <v-tabs
                        v-model="paymentOverviewTab"
                        centered
                        icons-and-text
                >
                  <v-tabs-slider color="primary"></v-tabs-slider>

                  <v-tab >

                    Participants
                    <v-icon>timeline</v-icon>
                  </v-tab>


                  <v-tab>
                    Payment History
                    <v-icon>receipt</v-icon>
                  </v-tab>
                </v-tabs>
              </v-flex>


            </v-card-title>



                <v-container v-if="paymentOverviewTab==0" style="border-top: lightgray 1px solid;">



                  <p class="pa-2" v-if="$structuredData.participants.length == 0">You have not added a participant yet</p>




                  <v-timeline v-else
                          dense
                  >


                    <v-timeline-item v-for="paymentDue in $structuredData.participants"  v-bind:key="paymentDue._id"

                            :color="paymentDue.color"
                            small
                            :icon="paymentDue.icon"
                    >
                      <v-layout pt-3 wrap>
                        <v-flex xs12 md6>
                          <strong style="font-size:16px">{{paymentDue.fullName}}</strong>
                          <br/>
                          <hr/>
                          <span>Payment Schedule:</span>
                          <v-layout row>
                            <v-flex v-for="paymentSchedule in paymentDue.paymentSchedule" style="border: 1px solid black;">
                              <v-icon v-if="paymentDue.PaymentProgress > paymentSchedule.progress" style="float: left; color:green">check_circle</v-icon>
                              <span>${{paymentSchedule.amount}}</span> <br/>
                              <span><b>{{paymentSchedule.date | moment("MM-DD-YYYY")}}</b></span>
                            </v-flex>
                          </v-layout>

                          <div class="caption"></div>
                        </v-flex>
                        <v-flex xs12 md6>
                          <div class="caption">

                            <strong class="paymentStatus" v-if="paymentDue.disabled" style="color:red">Disabled</strong>
                            <strong class="paymentStatus" v-else-if="paymentDue.PaymentProgress > 0 && paymentDue.percentPaid < 100" v-bind:style="{ color: paymentDue.color }">${{paymentDue.dueAmount}} Payment Due {{paymentDue.nextDue | moment("MMM Do")}}</strong>
                            <strong class="paymentStatus" v-else-if="paymentDue.Trip.remainingSpacePercent > 10 && paymentDue.PaymentProgress == 0" style="color:red">Deposit Payment Required Before {{paymentDue.nextDue | moment("MMM Do")}}</strong>

                            <strong class="paymentStatus" v-else-if="paymentDue.Trip.remainingSpacePercent < 11 && paymentDue.PaymentProgress == 0" style="color:red">Number of tour participants is limited. Space is not confirmed without deposit!</strong>
                            <strong class="paymentStatus" v-else-if="paymentDue.percentPaid == 100" style="color:green">Fully Paid!</strong>


                            <v-progress-linear class="paymentMeterBar" v-model="paymentDue.percentPaid"></v-progress-linear>
                            <span><strong>${{Number(paymentDue.totalFundRaised) + Number(paymentDue.totalPaid)}}</strong>  <span style="color:red;" v-if="paymentDue.totalFee >0">+ (${{paymentDue.totalFee}} Late Fees)</span> <span v-if="paymentDue.totalPending > 0" v-bind:style="{ color: paymentDue.color }"> + (${{paymentDue.totalPending}} pending)</span> of ${{paymentDue.selectedTripCost}}</span>



                          </div>

                          <small v-if="1==2" style="color: red; text-decoration: underline">(Late Fees Waived)</small>
                        </v-flex>
                      </v-layout>
                    </v-timeline-item>




                  </v-timeline>

                </v-container>

                <v-container v-if="paymentOverviewTab==1" style="border-top: lightgray 1px solid;">

                  <p class="pa-2" v-if=" this.$structuredData.payments.length == 0">No payment activity</p>



                  <v-timeline v-else
                          dense
                  >
                    <v-timeline-item v-for="payment in this.$structuredData.payments"
                                     color="primary"
                                     small
                    >
                      <v-layout pt-3>
                        <v-flex >
                          <v-card v-bind:class="payment.Status" >

                            <v-container >
                              <h4>${{payment.Amount}} {{payment.Type}}
                              </h4>



                            </v-container>
                            <v-container style="border-top: lightgray 1px solid;">
                              <v-layout row wrap>
                                <v-flex xs4 v-if="1==2">
                                  <span>{{payment.Type}}</span>
                                  <br/>
                                  <strong class="payUpdatesBottomLabels">Method</strong>
                                </v-flex>
                                <v-flex xs12 md3 sm6>
                                  <span>{{payment.Date | moment("MM/DD/YYYY")}}</span>
                                  <br/>
                                  <strong class="payUpdatesBottomLabels">{{payment.Status}}</strong>
                                </v-flex>
                                <v-flex xs12 md3 sm6>
                                  <span>{{payment.participant.firstName + ' ' + payment.participant.lastName}}</span>
                                  <br/>
                                  <strong class="payUpdatesBottomLabels">Participant</strong>
                                </v-flex>
                                <v-flex xs12 md6 v-if="payment.Notes && payment.Notes.length > 1" >
                                  <span>{{payment.Notes}}</span>
                                  <br/>
                                  <strong class="payUpdatesBottomLabels">Notes</strong>
                                </v-flex>
                                <v-flex xs12 md6 v-else-if="payment.StatusNote && payment.StatusNote.length > 1" >
                                  <span>{{payment.StatusNote}} on {{payment.StatusNoteDate | moment("MM/DD/YYYY")}} </span>
                                  <br/>
                                  <strong class="payUpdatesBottomLabels">Details</strong>
                                </v-flex>
                              </v-layout>
                            </v-container>

                          </v-card>
                        </v-flex>
                      </v-layout>
                    </v-timeline-item>

                  </v-timeline>

                </v-container>


          </v-card>

        </v-flex>


      </v-layout>
    </v-container>

  </section>

</template>

<script lang="js">
    import tripMessages from '../components/TripMessages'
    import moment from'moment';
  export default  {
    name: 'dashboard',
    props: [],
      components: {
          tripMessages
      },
    mounted() {

       // this.getPaymentDues()

        //this.getPaymentHistory()
    },
    data() {
      return {
          tabs: null,
          paymentOverviewTab: 0,
          testrtt: 70,
          displayRight: true,
          e1: 0,
          depositValue: 100,
          installment1: 100,
          installment2: 50,
          installment3: 0,
          installment4: 0,
          paymentHistory: [],
          paymentDues: []
      }
    },
    methods: {
        test() {
            console.log('test')
        },
        markAllRead(){
            this.$services.users.patch(this.$userData._id,
                {
                    "notifsRead":this.$structuredData.notifications.length,

                })
            this.$userData.notifsRead = this.$structuredData.notifications.length
        },
        getPaymentHistory() {
            console.log('in getPaymentHistory')
            let vueThis = this
            var toReturn = []
           /* this.$services.payments.find().then((payments) => {
                console.log('paaaaaaaaayments', payments.data)
                let paymentsList = payments.data
                console.log('get payments history says!!!!!!!', paymentsList)
                */
                this.paymentHistory =[]
            vueThis.$structuredData.participants.forEach((participant)=>{


                toReturn.push(participant.Payments)
                        toReturn.sort(function(a,b){
                            // Turn your strings into dates, and then subtract them
                            // to get a value that is either negative, positive, or zero.
                            console.log('dates', b.Date, a.Date)
                            return new Date(b.Date) - new Date(a.Date);
                        });

                this.paymentHistory =toReturn

            })

                /*vueThis.$services.users.find().then((users) => {
                    console.log('result of users find is', users.data)
                    paymentsList.forEach((payment) => {
                        console.log('traveler user', payment.TravelerUser)
                        var user = users.data.filter(obj => {
                            return obj._id === payment.TravelerUser
                        })[0]
                        payment.User = user
                    })


                    console.log('get payments history says!!!!!!!', paymentsList)
                    this.paymentHistory = paymentsList
                })*/

          //  })
        }
    },
    computed: {
        hasEnabledParticipants() {
            for (let participant of this.$structuredData.participants) {
                //this.$structuredData.participants.forEach((participant)=>{
                if (!participant.disabled) {
                    return true
                }
            }

            return false
        }
    }
}
</script>

<style scoped lang="scss">
.v-card.Voided {
  color: red;
}
.v-card.Voided h4 {
  text-decoration: line-through;
}

  .paymentStatus{
    font-size: 15px;
  }
  .dashboard {

  }
  .v-card {
    border: #d0c7c7 1px solid;
  }
  .payUpdatesBottomLabels {
    text-decoration: overline;
    font-size: 12px;
    position: relative;
    top: -3px;
  }
</style>
